import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ServerApiService } from './server-api.service';
import JSZip from 'node_modules/jszip/dist/jszip.min.js';
import JSZipUtils from 'node_modules/jszip-utils/dist/jszip-utils.min.js';
import { content } from 'html2canvas/dist/types/css/property-descriptors/content';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { CommonService } from './common.service';

@Injectable({
    providedIn: 'root'
})
export class ExportToExcelService {
    exportToExcelAPIs: any;

    constructor(private appService: AppService, private http: HttpClient, private apisService: ServerApiService, private commonService: CommonService) {
        this.exportToExcelAPIs = apisService.getApi.exportToExcel;

    }

    fetchDataToExport = function (dates, scenario, inputDetails, tempScenarioCalculationData, financialConfiguration, financialInputConfiguration, customerPOVConfiguration) {
        let params = {
            dates: dates,
            scenario: scenario,
            inputDetails: inputDetails,
            tempScenarioCalculationData: tempScenarioCalculationData,
            financialConfiguration: financialConfiguration,
            financialInputConfiguration: financialInputConfiguration,
            customerPOVConfiguration: customerPOVConfiguration
        }
        this.http.post(this.exportToExcelAPIs.fetchDataToExport, params).subscribe((result) => {
            return result.data;
        });
    }

    ExportData = function (params) {
        this.http.post(this.exportToExcelAPIs.exportData, params).subscribe((result) => {
            var dataToExport = result.data;

              let scenario = params.scenario;
        
        // Check if aliases are in the result
        if (result.dealAlias || result.noDealAlias) {
            // Attach aliases to scenario object for use in exportFile
            scenario.dealAlias = result.dealAlias;
            scenario.noDealAlias = result.noDealAlias;
        } else {
            console.warn('No aliases found in backend response. Using defaults.');
            scenario.dealAlias = 'Deal';
            scenario.noDealAlias = 'No Deal';
        }
        
            this.exportFile(params.scenario, dataToExport, false);
        });
    }

    ExportMasterScenarioData = function (masterScenario) {
        let params = {
            childScenarioList: masterScenario.ChildScenarioList,
            childScenarioCount: masterScenario.ChildScenarioCount
        }
        this.http.post(this.exportToExcelAPIs.exportMasterScenarioData, params).subscribe((result) => {
            var masterExportData = result.masterExportData;
            this.exportFile(masterScenario, masterExportData, true);
        });
    }

    exportDataPBC = function (dates, scenario, inputDetails, dbPricingExpenses, financialConfiguration, tempProduct, contractExpectationsSummary, scenarioDetails, returnOnContract, providerPoVDdb, customerPOVPBCConfiguration, adoptionCurveQuarter, segmentList, breakEvenRebate, tempUOMValues, lastDataRefreshDate, projectionMethods, resources, discountSummaryJson) {
        let params = {
            dates,
            scenario,
            inputDetails,
            dbPricingExpenses,
            financialConfiguration,
            tempProduct,
            contractExpectationsSummary,
            scenarioDetails,
            returnOnContract,
            providerPoVDdb,
            customerPOVPBCConfiguration,
            adoptionCurveQuarter,
            segmentList,
            breakEvenRebate,
            tempUOMValues,
            lastDataRefreshDate,
            projectionMethods,
            resources,
            discountSummaryJson
        }
        this.http.post(this.exportToExcelAPIs.fetchDataToExportPBC, params).subscribe((result) => {
            var dataToExport = result.data;
            this.exportFile(scenario, dataToExport, false, result.team);
        });
    }

    fetchDataToExportPBC = function (dates, scenario, inputDetails, dbPricingExpenses, financialConfiguration, tempProduct, contractExpectationsSummary, scenarioDetails, returnOnContract, PBCQuarterInfoDates, pov, providerPoVDdb, customerPOVPBCConfiguration, adoptionCurveQuarter, segmentList, breakEvenRebate, tempUOMValues) {
        let params = {
            dates: dates,
            scenario: scenario,
            inputDetails: inputDetails,
            dbPricingExpenses: dbPricingExpenses,
            financialConfiguration: financialConfiguration,
            tempProduct: tempProduct,
            contractExpectationsSummary: contractExpectationsSummary,
            scenarioDetails: scenarioDetails,
            returnOnContract: returnOnContract,
            PBCQuarterInfoDates: PBCQuarterInfoDates,
            pov: pov,
            providerPoVDdb: providerPoVDdb,
            customerPOVPBCConfiguration: customerPOVPBCConfiguration,
            adoptionCurveQuarter: adoptionCurveQuarter,
            segmentList: segmentList,
            breakEvenRebate: breakEvenRebate,
            tempUOMValues: tempUOMValues
        }
        this.http.post(this.exportToExcelAPIs.fetchDataToExportPBC, params).subscribe((result) => {
            var dataToExport = result.data;
            return dataToExport;
        });
    }
    s2ab = function (s: string): Uint8Array {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) {
          view[i] = s.charCodeAt(i) & 0xFF;
        }
        return view;
      }
// Function to convert data to string format
    formatDataToString = function (data: any[][]): string[][] {
    return data.map(row => Array.isArray(row) ? row.map(cell => String(cell)) : [String(row)]);
}

    exportFile = function (scenario, dataToExport, isMasterExport, team) {
        if(team !== 'PBC'){
        let includeTemplate = false;
        if (!isMasterExport) {
            var scenarioVersion = scenario.ScenarioSummary.ScenarioVersion;
            if (scenario.ScenarioSummary.ScenarioVersion >= 4) {
                scenarioVersion = parseFloat(Number(scenario.ScenarioSummary.ScenarioVersion).toFixed(2));
            }
        }
        var zip = new JSZip();
        var templatePath;
        var fileName;
        var exportFolder = zip.folder("Export");
        if (isMasterExport) {
            fileName = scenario.MasterScName;
            if (this.appService.resources.Export_Master_Scenario.Visible == 'N') {
                
                let a2 = [];
                for (let i = 0; i < dataToExport.length; i++) {
                    // Parse the export data
                    let a1 = JSON.parse(dataToExport[i].exportData);
                    a2.push(a1);
                }

                for (let j = 0; j < a2.length; j++) {
                    const wb: XLSX.WorkBook = XLSX.utils.book_new();

                     const childScenario = dataToExport[j];
                   const dealAlias = childScenario.dealAlias || "Deal";
                    const noDealAlias = childScenario.noDealAlias || "No Deal";
                    // Push blank row (optional)
                  const scenarioInputsData = [...a2[j].scenario_Inputs];
                    
                    // Push blank row (optional)
                    scenarioInputsData.push([""]);
                    // Add heading
                    scenarioInputsData.push(["Sub Scenario"]);
                    scenarioInputsData.push([""]);
                    // Add headers
                    scenarioInputsData.push(["Deal", "No Deal"]);
                    // Add alias values
                    scenarioInputsData.push([dealAlias, noDealAlias]);
                    const sheetData = {
                        // Data: this.formatDataToString(a2[j])
                                Scenario_Details: this.formatDataToString(scenarioInputsData),
                                Affiliations_data: this.formatDataToString(a2[j].affiliation_data),
                                EditBaseline: this.formatDataToString(a2[j].editBaseline),
                                Baseline_and_ContractDetails: this.formatDataToString(a2[j].baselineandContractDetails),
                                Contract_Expectations: this.formatDataToString(a2[j].contract_Expectations),
                                Contract_Financials: this.formatDataToString(a2[j].contract_Financials),
                                Customer_POV: this.formatDataToString(a2[j].customer_Pov),
                    };

                    for (const sheetName in sheetData) {
                        if (sheetData.hasOwnProperty(sheetName)) {
                            const data = sheetData[sheetName];
                            const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
                            XLSX.utils.book_append_sheet(wb, ws, sheetName);
                        }
                    }

                    const wbout = XLSX.write(wb, {bookType: 'xlsx', type: 'binary'});

                    const excelBlob = new Blob([this.s2ab(wbout)], {type: 'application/octet-stream'});
                        
                    const exportFileName = `${dataToExport[j].scenarioName}.xlsx`;
                    exportFolder.file(exportFileName, excelBlob);
    
}

                templatePath = "";
            }
            else {
                let a2 = [];
                for (let i = 0; i < dataToExport.length; i++) {
                    // Parse the export data
                    let a1 = JSON.parse(dataToExport[i].exportData);
                    a2.push(a1);
                }

                for (let j = 0; j < a2.length; j++) {
                    const wb: XLSX.WorkBook = XLSX.utils.book_new();

                    const childScenario = dataToExport[j];
                    const dealAlias = childScenario.dealAlias || "Deal";
                    const noDealAlias = childScenario.noDealAlias || "No Deal";

                     // Prepare scenario inputs with aliases
                    const scenarioInputsData = [...a2[j].scenario_Inputs];
                    
                    // Push blank row (optional)
                    scenarioInputsData.push([""]);
                    // Add heading
                    scenarioInputsData.push(["Sub Scenario"]);
                    scenarioInputsData.push([""]);
                    // Add headers
                    scenarioInputsData.push(["Deal", "No Deal"]);
                    // Add alias values
                    scenarioInputsData.push([dealAlias, noDealAlias]);
                    
                    const sheetData = {
                        // Data: this.formatDataToString(a2[j])
                                Scenario_Details: this.formatDataToString(scenarioInputsData),
                                Affiliations_data: this.formatDataToString(a2[j].affiliation_data),
                                EditBaseline: this.formatDataToString(a2[j].editBaseline),
                                Baseline_and_ContractDetails: this.formatDataToString(a2[j].baselineandContractDetails),
                                Contract_Expectations: this.formatDataToString(a2[j].contract_Expectations),
                                Contract_Financials: this.formatDataToString(a2[j].contract_Financials),
                                Customer_POV: this.formatDataToString(a2[j].customer_Pov),
                    };

                    for (const sheetName in sheetData) {
                        if (sheetData.hasOwnProperty(sheetName)) {
                            const data = sheetData[sheetName];
                            const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
                            XLSX.utils.book_append_sheet(wb, ws, sheetName);
                        }
                    }

                    const wbout = XLSX.write(wb, {bookType: 'xlsx', type: 'binary'});

                    const excelBlob = new Blob([this.s2ab(wbout)], {type: 'application/octet-stream'});
                        
                    const exportFileName = `${dataToExport[j].scenarioName}.xlsx`;
                    exportFolder.file(exportFileName, excelBlob);
                }
                templatePath = "MasterExport/" + this.appService.resourceFields.Client_Name.text + "/Export Template.xlsm";
            }
        }
        else {
            fileName = scenario.ScenarioSummary.ScName;
            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            const dealAlias = scenario.ScenarioSummary.dealAlias || "Deal";
            const noDealAlias = scenario.ScenarioSummary.noDealAlias || "No Deal";
             // Prepare scenario inputs with aliases
            const scenarioInputsData = [...dataToExport.scenario_Inputs];
            
            // Push blank row (optional)
            scenarioInputsData.push([""]);
            // Add heading
            scenarioInputsData.push(["Sub Scenario"]);
            scenarioInputsData.push([""]);
            // Add headers
            scenarioInputsData.push(["Deal", "No Deal"]);
            // Add alias values
            scenarioInputsData.push([dealAlias, noDealAlias]);
            const sheetData = {
                
                Scenario_Details: this.formatDataToString(scenarioInputsData),
                Affiliations_data: this.formatDataToString(dataToExport.affiliation_data),
                EditBaseline: this.formatDataToString(dataToExport.editBaseline),
                Baseline_and_ContractDetails: this.formatDataToString(dataToExport.baselineandContractDetails),
                Contract_Expectations: this.formatDataToString(dataToExport.contract_Expectations),
                Contract_Financials: this.formatDataToString(dataToExport.contract_Financials),
                Customer_POV: this.formatDataToString(dataToExport.customer_Pov),
            };
    
            for (const sheetName in sheetData) {
                if (sheetData.hasOwnProperty(sheetName)) {
                    const data = sheetData[sheetName];
                    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
                    XLSX.utils.book_append_sheet(wb, ws, sheetName);
                }
            }
    
            // Generate Excel file content
            const wbout = XLSX.write(wb, {bookType: 'xlsx', type: 'binary'});
    
            // Convert binary to Blob
            const excelBlob = new Blob([this.s2ab(wbout)], {type: 'application/octet-stream'});
    
            const exportFileName = fileName + ".xlsx";
            // Add the Excel file to the export folder
            exportFolder.file(exportFileName, excelBlob);
    
            templatePath = "";
            includeTemplate = false;
        }
    
        JSZipUtils.getBinaryContent(templatePath, (err, data) => {
            if (err) {
                throw err; // or handle the error
            }
            if (isMasterExport == true) {
                if (this.appService.resources.Export_Master_Scenario.Visible == 'Y') {
                    zip.file("Export Template.xlsm", data, { binary: true });
                }
            }
            else {
                if (includeTemplate) {
                    zip.file("Export Template.xlsm", data, { binary: true });
                }
            }
            var isIE11 = this.getInternetExplorerVersion() === 11 ? true : false;
            if (isIE11) {
                zip.generateAsync({ type: "blob" }).then(blob => {
                    var IEwindow = window.open();
                    if ('msSaveBlob' in window.navigator) {
                        (window.navigator as any ).msSaveBlob(blob, fileName + ".zip");
                    }
                    IEwindow.close();
                });
            } else {
                zip.generateAsync({ type: "blob" }).then(content => {
                    var elem = window.document.createElement('a');
                    elem.href = window.URL.createObjectURL(content);
                    elem.download = fileName;
                    document.body.appendChild(elem);
                    elem.click();
                    document.body.removeChild(elem);
                });
            }
        });
    }
    else{
        let includeTemplate = false;
        if (!isMasterExport) {
            var scenarioVersion = scenario.ScenarioSummary.ScenarioVersion;
            if (scenario.ScenarioSummary.ScenarioVersion >= 4) {
                scenarioVersion = parseFloat(Number(scenario.ScenarioSummary.ScenarioVersion).toFixed(2));
            }
        }
        var zip = new JSZip();
        var templatePath;
        var fileName;
        var exportFolder = zip.folder("Export");
        if (isMasterExport) {
            fileName = scenario.MasterScName;
            if (this.appService.resources.Export_Master_Scenario.Visible == 'N') {

                for (var i = 0; i < dataToExport.length; i++) {
                    exportFolder.file(dataToExport[i].scenarioName + ".csv", dataToExport[i].exportData.toString());
                }
                templatePath = "";
            }
            else {

                for (var i = 0; i < dataToExport.length; i++) {
                    exportFolder.file(dataToExport[i].scenarioName + "_" + "Data.csv", dataToExport[i].exportData.toString());

                }
                templatePath = "MasterExport/" + this.appService.resourceFields.Client_Name.text + "/Export Template.xlsm";
            }
        }
        else {
            fileName = scenario.ScenarioSummary.ScName;
            // if ((parseInt(scenario.ScenarioSummary.ScenarioVersion) >= 6 && (team == undefined || team.toUpperCase() == 'UBC')) || (parseInt(scenario.ScenarioSummary.ScenarioVersion) >= 7 && (team == undefined || team.toUpperCase() == 'PBC'))) {
            exportFolder.file(scenario.ScenarioSummary.ScName + ".csv", dataToExport.toString());
            templatePath = "";
            includeTemplate = false;
            // }
            // else {
            //   exportFolder.file("Data.csv", dataToExport.toString());
            //   templatePath = "Export/" + this.appService.loggedInUser.team + "/" + this.appService.resourceFields.Client_Name.text + "/" + scenario.ScenarioSummary.ScenarioVersion + "/Export Template.xlsm";
            //   includeTemplate = true;
            // }
        }

        JSZipUtils.getBinaryContent(templatePath, (err, data) => {
            if (err) {
                throw err; // or handle the error
            }
            if (isMasterExport == true) {
                if (this.appService.resources.Export_Master_Scenario.Visible == 'Y') {
                    exportFolder.file("Export Template.xlsm", data, { binary: true });
                }

            }
            else {
                if (includeTemplate) {

                    exportFolder.file("Export Template.xlsm", data, { binary: true });
                }
            }
            var isIE11 = this.getInternetExplorerVersion() === 11 ? true : false;
            if (isIE11) {
                zip.generateAsync({ type: "blob" }).then(blob => {
                    var IEwindow = window.open();
                    // window.navigator.msSaveBlob(blob, fileName + ".zip");
                    if ('msSaveBlob' in window.navigator) {
                        (window.navigator as any ).msSaveBlob(blob, fileName + ".zip");
                    }
                    IEwindow.close();
                });
            } else {
                zip.generateAsync({ type: "blob" }).then(content => {
                    var elem = window.document.createElement('a');
                    elem.href = window.URL.createObjectURL(content);
                    elem.download = fileName;
                    document.body.appendChild(elem);
                    elem.click();
                    document.body.removeChild(elem);
                });
            }

        });
    }
    }
    
    // exportFile = function (scenario, dataToExport, isMasterExport, team) {

    //     let includeTemplate = false;
    //     if (!isMasterExport) {
    //         var scenarioVersion = scenario.ScenarioSummary.ScenarioVersion;
    //         if (scenario.ScenarioSummary.ScenarioVersion >= 4) {
    //             scenarioVersion = parseFloat(Number(scenario.ScenarioSummary.ScenarioVersion).toFixed(2));
    //         }
    //     }
    //     var zip = new JSZip();
    //     var templatePath;
    //     var fileName;
    //     var exportFolder = zip.folder("Export");
    //     if (isMasterExport) {
    //         fileName = scenario.MasterScName;
    //         if (this.appService.resources.Export_Master_Scenario.Visible == 'N') {

    //             for (var i = 0; i < dataToExport.length; i++) {
    //                 exportFolder.file(dataToExport[i].scenarioName + ".csv", dataToExport[i].exportData.toString());
    //             }
    //             templatePath = "";
    //         }
    //         else {

    //             for (var i = 0; i < dataToExport.length; i++) {
    //                 exportFolder.file(dataToExport[i].scenarioName + "_" + "Data.csv", dataToExport[i].exportData.toString());

    //             }
    //             templatePath = "MasterExport/" + this.appService.resourceFields.Client_Name.text + "/Export Template.xlsm";
    //         }
    //     }
    //     else {
    //         fileName = scenario.ScenarioSummary.ScName;
    //         // const wb: XLSX.WorkBook = XLSX.utils.book_new();

    //         // const sheetData = {
    //         //     Scenario_Inputs: this.formatDataToString(dataToExport.scenario_Inputs),
    //         //     Affiliations_data: this.formatDataToString(dataToExport.affiliation_data),
    //         //     EditBaseline: this.formatDataToString(dataToExport.editBaseline),
    //         //     Baseline_and_ContractDetails: this.formatDataToString(dataToExport.baselineandContractDetails),
    //         //     Contract_Expectations: this.formatDataToString(dataToExport.contract_Expectations),
    //         //     Contract_Financials: this.formatDataToString(dataToExport.contract_Financials),
    //         //     Customer_POV: this.formatDataToString(dataToExport.customer_Pov),
   
    //         // };
            
    //         // for (const sheetName in sheetData) {
    //         //     if (sheetData.hasOwnProperty(sheetName)) {
    //         //         const data = sheetData[sheetName];
    //         //         const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    //         //         XLSX.utils.book_append_sheet(wb, ws, sheetName);
    //         //     }
    //         // }

        
    //         // // Generate Excel file content
    //         // const wbout = XLSX.write(wb, {bookType: 'xlsx', type: 'binary'});
        
    //         // // Convert binary to Blob
    //         // const excelBlob = new Blob([this.s2ab(wbout)], {type: 'application/octet-stream'});
            
    //         // if ((parseInt(scenario.ScenarioSummary.ScenarioVersion) >= 6 && (team == undefined || team.toUpperCase() == 'UBC')) || (parseInt(scenario.ScenarioSummary.ScenarioVersion) >= 7 && (team == undefined || team.toUpperCase() == 'PBC'))) {
    //         // exportFolder.file(scenario.ScenarioSummary.ScName + ".csv", dataToExport.scenario_Inputs.toString());
    //         exportFolder.file(scenario.ScenarioSummary.ScName + ".csv", dataToExport.contract_Financials.toString());

  
    //         // const exportFileName = fileName + ".xlsx";
    //         // saveAs(excelBlob, exportFileName);
    //         templatePath = "";
    //         includeTemplate = false;
    //         // }
    //         // else {
    //         //   exportFolder.file("Data.csv", dataToExport.toString());
    //         //   templatePath = "Export/" + this.appService.loggedInUser.team + "/" + this.appService.resourceFields.Client_Name.text + "/" + scenario.ScenarioSummary.ScenarioVersion + "/Export Template.xlsm";
    //         //   includeTemplate = true;
    //         // }
    //     }
        
    
    //     JSZipUtils.getBinaryContent(templatePath, (err, data) => {
    //         if (err) {
    //             throw err; // or handle the error
    //         }
    //         if (isMasterExport == true) {
    //             if (this.appService.resources.Export_Master_Scenario.Visible == 'Y') {
    //                 zip.file("Export Template.xlsm", data, { binary: true });
    //             }

    //         }
    //         else {
    //             if (includeTemplate) {

    //                 zip.file("Export Template.xlsm", data, { binary: true });
    //             }
    //         }
    //         var isIE11 = this.getInternetExplorerVersion() === 11 ? true : false;
    //         if (isIE11) {
    //             zip.generateAsync({ type: "blob" }).then(blob => {
    //                 var IEwindow = window.open();

    //                 // check this after upgrade
    //                 if ('msSaveBlob' in window.navigator) {
    //                     (window.navigator as any ).msSaveBlob(blob, fileName + ".zip");
    //                 }
                    
    //                 //window.navigator.msSaveBlob(blob, fileName + ".zip");
    //                 IEwindow.close();
    //             });
    //         } else {
    //             zip.generateAsync({ type: "blob" }).then(content => {
    //                 var elem = window.document.createElement('a');
    //                 elem.href = window.URL.createObjectURL(content);
    //                 elem.download = fileName;
    //                 document.body.appendChild(elem);
    //                 elem.click();
    //                 document.body.removeChild(elem);
    //             });
    //         }

    //     });
    // }

    getInternetExplorerVersion() {
        var rv = -1;
        if (navigator.appName == 'Microsoft Internet Explorer') {
            var ua = navigator.userAgent;
            var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
            if (re.exec(ua) != null)
                rv = parseFloat(RegExp.$1);
        }
        else if (navigator.appName == 'Netscape') {
            var ua = navigator.userAgent;
            var re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
            if (re.exec(ua) != null)
                rv = parseFloat(RegExp.$1);
        }
        return rv;
    }



    exportDataPBCOld = function (dates, scenario, inputDetails, dbPricingExpenses, financialConfiguration, tempProduct, contractExpectationsSummary, scenarioDetails, returnOnContract, PBCQuarterInfoDates, pov, providerPoVDdb, customerPOVPBCConfiguration, adoptionCurveQuarter, segmentList, team) {
        var dataToExport = this.fetchDataToExportPBCOld(dates, scenario, inputDetails, dbPricingExpenses, financialConfiguration, tempProduct, contractExpectationsSummary, scenarioDetails, returnOnContract, PBCQuarterInfoDates, pov, providerPoVDdb, customerPOVPBCConfiguration, adoptionCurveQuarter, segmentList);

        this.exportFile(scenario, dataToExport, false, team);
    }



    fetchDataToExportPBCOld = function (dates, scenario, inputDetails, dbPricingExpenses, financialConfiguration, tempProduct, contractExpectationsSummary, scenarioDetails, returnOnContract, PBCQuarterInfoDates, pov, providerPoVDdb, customerPOVPBCConfiguration, adoptionCurveQuarter, segmentList) {
        var inputDetailsData = this.commonService.deepCopy(inputDetails);
        var dataToExport = [];
        var months = [];
        var quarters = [];
        var contractQuarters = [];
        var flag = [];
        var aspSummary = this.commonService.deepCopy(inputDetails.ASP);
        var nationalForecastData = scenario.ScenarioSummary.nationalForecastData;
        var source = scenario.ScenarioSummary.PBCSummary.Source.selected;
        var segCustomerPOV = this.convertCustomerPOVToReqForm(customerPOVPBCConfiguration, 'segment', providerPoVDdb, dates);

        for (var i = 0; i < dates.length; i++) {
            months[i] = '\'' + dates[i].mon.toString();
            if (dates[i].Historical === 1) {
                flag[i] = 'H';
            } else if (dates[i].Forecast === 1) {
                flag[i] = 'F';
            }
        }
        var index = 0;
        for (var i = 0; i < dates.length; i++) {
            if (quarters.indexOf(dates[i].qtr) === -1) {
                quarters[index] = dates[i].qtr.toString();
                index += 1;
            }
        }

        index = 0;
        for (var i = 0; i < dates.length; i++) {
            if (contractQuarters.indexOf(dates[i].qtr) === -1 && dates[i].Contract === 1) {
                contractQuarters[index] = dates[i].qtr.toString();
                index += 1;
            }
        }
        for (var i = 0; i < (scenarioDetails.SegmentImpacts).length; i++) {
            if (scenarioDetails.SegmentImpacts[i].SegmentName === "") {
                scenarioDetails.SegmentImpacts[i].SegmentName = "-";
                scenario.AffiliationData[source].Data[i].Segment = "-";
            }
        }
        //creating segment key value
        var segKeyVal = {};
        var segVal = 1;
        for (var i = 0; i < segmentList.length; i++) {
            segKeyVal[segmentList[i].SegmentName] = segVal;
            segVal = segVal + 1;
        }
        segKeyVal['overAll'] = 0;

        dataToExport.push("Scenario Inputs \n");
        dataToExport.push("\n Scenario Details \n");
        dataToExport.push(["Project Name", "Scenario Id", "Scenario Name", "#Affilated Entity", "Scenario Status", "Created By", "Created Date", "Modified Date", "Contract Start Date", "Contract End Date", "Client Product", "Therapy Area", "Current Data"]);
        dataToExport.push("\n");


        var projectName = this.commonService.deepCopy(scenario.ProjectSummary.Projectname);
        projectName = "\"" + projectName + "\"";

        var scenarioName = this.commonService.deepCopy(scenario.ScenarioSummary.ScName);
        scenarioName = "\"" + scenarioName + "\"";

        var eligibleEntityCount = scenario.AffiliationData[scenario.ScenarioSummary.PBCSummary.Source.selected].Data.length;
        dataToExport.push([projectName, scenario.ScenarioSummary.ScenarioID, scenarioName, eligibleEntityCount,
            scenario.ScenarioSummary.Status, scenario.ScenarioSummary.CreatedBy, scenario.ScenarioSummary.CreatedDate, scenario.ScenarioSummary.ModifiedDate, scenario.ScenarioSummary.contractStartDate, scenario.ScenarioSummary.contractEndDate, scenario.ScenarioSummary.affiliationMonthlyQuarterlyData[0].Name, scenario.ProjectSummary.Market, this.appService.lastDataRefreshDate]);
        dataToExport.push('\n');

        if (source != 'Custom') {
            var selectedAttributes = scenario.AffiliationData[scenario.ScenarioSummary.PBCSummary.Source.selected]
                .AttributeListArray;
            dataToExport.push("\n Selected Attributes \n");
            for (var i = 0; i < selectedAttributes.length; i++) {
                dataToExport.push(selectedAttributes[i]);

            }
            dataToExport.push("\n");
        }
        dataToExport.push("\n Affiliation Data \n");
        if (source === 'Account') {
            dataToExport.push("Source selected", "ID", "Account Name", "Segment", "Enrollment Data", "Eligible Volume Percent \n");
            for (var i = 0; i < scenario.AffiliationData[source].Data.length; i++) {
                dataToExport.push(source, scenario.AffiliationData[source].Data[i].ID, scenario.AffiliationData[source].Data[i].AccountName, scenario.AffiliationData[source].Data[i].Segment, scenario.AffiliationData[source].Data[i].EnrollmentDate, scenario.AffiliationData[source].Data[i].EligibleVolumePercent);
                dataToExport.push("\n");
            }
        } else if (source === 'Facility') {
            dataToExport.push("Source selected", "ID", "Facility Name", "Segment", "Enrollment Data", "IsEligible \n");
            for (var i = 0; i < scenario.AffiliationData[source].Data.length; i++) {
                dataToExport.push(source, scenario.AffiliationData[source].Data[i].ID, "-", scenario.AffiliationData[source].Data[i].Segment, scenario.AffiliationData[source].Data[i].EnrollmentDate, scenario.AffiliationData[source].Data[i].IsEligible);
                dataToExport.push("\n");
            }

        }


        dataToExport.push("\n Baseline and Contract Details \n");

        dataToExport.push(["Selected Unit of Measurement:"], inputDetailsData.SelectedUOMText, "\n");
        dataToExport.push("\n");
        dataToExport.push("Product", "Volume", "Sales", "Share(%)");
        dataToExport.push("\n");
        for (var j = 0; j < tempProduct.ProductLevel.length; j++) {
            if (tempProduct.ProductLevel[j].IsIncluded) {
                dataToExport.push(tempProduct.ProductLevel[j].Name, tempProduct.ProductLevel[j].Baseline[inputDetailsData.SelectedUOM].Volume, tempProduct.ProductLevel[j].Baseline.Gross_Sales.Volume, tempProduct.ProductLevel[j].Baseline[inputDetailsData.SelectedUOM].Share);
                dataToExport.push("\n");
            }
        }

        //baseline deal and noDeal
        dataToExport.push("\n TRX Volume \n");
        dataToExport.push("Segment", "Product", "Metric");
        for (var p = 0; p < months.length; p++) {
            dataToExport.push(months[p]);
        }
        dataToExport.push("\n");

        for (let s = 0; s < segmentList.length; s++) {
            for (var i = 0; i < (scenario.ScenarioSummary.affiliationMonthlyQuarterlyData).length; i++) {
                if (tempProduct.ProductLevel[i].Name === scenario.ScenarioSummary.affiliationMonthlyQuarterlyData[i].Name && tempProduct.ProductLevel[i].IsIncluded) {
                    var baseline = [];
                    var deal = [];
                    var noDeal = [];
                    for (var k = 0; k < (scenario.ScenarioSummary.affiliationMonthlyQuarterlyData[0].ByFacility[0].data['Units'].Volume.Monthly).length; k++) {
                        baseline.push(0);
                        deal.push(0);
                        noDeal.push(0);

                    }
                    var segmentName: any = segmentList[s].SegmentName;
                    dataToExport.push(segKeyVal[segmentName]);
                    dataToExport.push(scenario.ScenarioSummary.affiliationMonthlyQuarterlyData[i].Name);
                    for (var j = 0; j < (scenario.ScenarioSummary.affiliationMonthlyQuarterlyData[i].ByFacility).length; j++) {
                        if (scenario.ScenarioSummary.affiliationMonthlyQuarterlyData[i].ByFacility[j].segment == segmentList[s].SegmentName) {
                            for (var k = 0; k < (scenario.ScenarioSummary.affiliationMonthlyQuarterlyData[i].ByFacility[j].data['Units'].Volume.Monthly).length; k++) {
                                baseline[k] += scenario.ScenarioSummary.affiliationMonthlyQuarterlyData[i].ByFacility[j].data['Units'].Volume.Monthly[k];
                                deal[k] += scenario.ScenarioSummary.affiliationMonthlyQuarterlyData[i].ByFacility[j].data['Units'].Volume.deal.data[k];
                                noDeal[k] += scenario.ScenarioSummary.affiliationMonthlyQuarterlyData[i].ByFacility[j].data['Units'].Volume.noDeal.data[k];
                            }
                        }
                    }

                    dataToExport.push("Baseline");
                    for (var k = 0; k < (scenario.ScenarioSummary.affiliationMonthlyQuarterlyData[0].ByFacility[0].data['Units'].Volume.Monthly).length; k++) {
                        dataToExport.push(baseline[k]);
                    }
                    dataToExport.push("\n");

                    dataToExport.push(segKeyVal[segmentName]);
                    dataToExport.push(scenario.ScenarioSummary.affiliationMonthlyQuarterlyData[i].Name);
                    dataToExport.push("Deal");
                    for (var k = 0; k < (scenario.ScenarioSummary.affiliationMonthlyQuarterlyData[0].ByFacility[0].data['Units'].Volume.Monthly).length; k++) {
                        dataToExport.push(deal[k]);
                    }
                    dataToExport.push("\n");
                    dataToExport.push(segKeyVal[segmentName]);
                    dataToExport.push(scenario.ScenarioSummary.affiliationMonthlyQuarterlyData[i].Name);
                    dataToExport.push("NoDeal");
                    for (var k = 0; k < (scenario.ScenarioSummary.affiliationMonthlyQuarterlyData[0].ByFacility[0].data['Units'].Volume.Monthly).length; k++) {
                        dataToExport.push(noDeal[k]);
                    }
                    dataToExport.push("\n");


                }
            }
        }

        //Deal
        dataToExport.push("\n Deal \n");

        segmentList.forEach((val, segmentIndex) => {
            var segmentName: any = segmentList[segmentIndex].SegmentName;
            dataToExport.push("\n Segment : " + segmentName + " \n");
            if (inputDetailsData.AdminFees[segmentName].Flat.IsIncluded.deal) {
                dataToExport.push("\n D Flat Admin Fees - " + segKeyVal[segmentName], "Y \n");
                dataToExport.push("\n D Admin Fee Evaluation Method - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].Flat.EvaluationMethod.deal.selected, "\n");
                dataToExport.push(["\nD Admin Fee Metric"] + " - " + segKeyVal[segmentName]);
                for (var k = 0; k < months.length; k++) {
                    dataToExport.push(months[k]);
                }
                dataToExport.push(["\n D Admin Fees"] + " - " + segKeyVal[segmentName]);
                for (var k = 0; k < dates.length; k++) {
                    dataToExport.push(inputDetailsData.AdminFees[segmentName].Flat.Data.deal.Monthly[k]);
                }
                dataToExport.push("\n");
            }
            if (inputDetailsData.AdminFees[segmentName].PerformanceBased.IsIncluded.deal) {

                dataToExport.push("\n D Performance Based Admin Fees - " + segKeyVal[segmentName], "Y \n");
                dataToExport.push("\n D Performance Level To Apply - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.LevelToApply.deal.selected);
                if (scenario.ScenarioSummary.PBCSummary.Source.selected === 'Facility') {
                    dataToExport.push("\n D Performance Evaluation Level - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.EvaluationLevelsForFacility.deal.selected);
                } else if (scenario.ScenarioSummary.PBCSummary.Source.selected === 'Account') {
                    dataToExport.push("\n D Performance Evaluation Level - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.EvaluationLevelsForAccount.deal.selected);
                } else if (scenario.ScenarioSummary.PBCSummary.Source.selected === 'Custom') {
                    dataToExport.push("\n D Performance Evaluation Level - " + +segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.EvaluationLevelsForCustom.deal.selected);
                }
                dataToExport.push("\nD Performance Type - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.deal.selected);
                if (inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.deal.selected === 'Absolute') {
                    dataToExport.push("\n D Performance Type Metric - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.Absolute.PerformanceTierBasedOn.deal.selected);
                }
                else if (inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.deal.selected === 'Growth') {
                    dataToExport.push("\n D Performance Type Metric - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.Growth.PerformanceTierBasedOn.deal.selected);
                }
                dataToExport.push("\n");
                dataToExport.push("\n D Performance Tier Classification - " + segKeyVal[segmentName], "\n");
                dataToExport.push("\n D Performance Tier Selected UOM - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.UOM.deal.SelectedUOMText);
                dataToExport.push("\n D Performance Tier Number Of Tiers - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.NumberOfTiers.deal);
                dataToExport.push("\n D Performance Tier Evaluation Period Type - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.EvaluationPeriodType.deal.selected);
                dataToExport.push("\n");
                if (inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.deal.selected === 'Growth') {
                    if (inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.Growth.EvaluationBase.deal === 'Fixed') {
                        dataToExport.push("\nD Performance Tier Fixed Base - " + segKeyVal[segmentName]);
                        dataToExport.push("\n D Performance Tier Start Month - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.Growth.Fixed.StartMonth.deal.selected);
                        dataToExport.push("\n D Performance Tier End Month - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.Growth.Fixed.EndMonth.deal.selected);
                        dataToExport.push("\n D Performance Tier Evaluation Method - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.Growth.Fixed.EvaluationMethod.deal.selected);

                    } else if (inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.Growth.EvaluationBase.deal === 'Floating') {
                        dataToExport.push("\n D Performance Tier Floating Base - " + segKeyVal[segmentName]);
                        dataToExport.push("\n D Performance Tier Offset - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.Growth.Floating.Offset.deal);

                    }
                }
                dataToExport.push("\n");
                dataToExport.push("\n D Performance Tier Admin Fee Lag - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.Lag.deal);
                dataToExport.push("\n");
                dataToExport.push("\n D Admin Fee Tiers - " + segKeyVal[segmentName], "\n");
                dataToExport.push("\n D Admin Fee Tier Volume/Share tier threshold - " + segKeyVal[segmentName]);
                for (var l = 0; l < inputDetailsData.AdminFees[segmentName].PerformanceBased.Data.deal.Tiers.length; l++) {
                    dataToExport.push(inputDetailsData.AdminFees[segmentName].PerformanceBased.Data.deal.Tiers[l]);
                }
                dataToExport.push("\n D Performance Tier Admin Fee(%) - " + segKeyVal[segmentName]);
                for (var l = 0; l < inputDetailsData.AdminFees[segmentName].PerformanceBased.Data.deal.Values.length; l++) {
                    dataToExport.push(inputDetailsData.AdminFees[segmentName].PerformanceBased.Data.deal.Values[l]);
                }
            }
            dataToExport.push("\n");
            //Discount Structures
            if (inputDetailsData.DiscountStructures[segmentName].deal.selected === 'GNUP') {
                dataToExport.push("\n D Discount GNUP - " + segKeyVal[segmentName], "\n");
                dataToExport.push(["D Discount Metric"] + " " + segKeyVal[segmentName]);
                for (var k = 0; k < contractQuarters.length; k++) {
                    dataToExport.push(contractQuarters[k]);
                }
                dataToExport.push("\n");
                dataToExport.push(["D Discount Net Unit Price"] + " " + segKeyVal[segmentName]);
                for (var k = 0; k < quarters.length; k++) {
                    if (scenario.PBCQuarterInfoDates[k].Contract === 1) {
                        dataToExport.push(inputDetailsData.DiscountStructures[segmentName].Gnup.Data.deal.Quarterly[k]);
                    }
                }
                dataToExport.push("\n");
                dataToExport.push(["D Discount WAC Per Unit"] + " " + segKeyVal[segmentName]);
                for (var i = 0; i < (scenario.PBCQuarterInfoDates).length; i++) {
                    if (scenario.PBCQuarterInfoDates[i].Contract === 1) {
                        dataToExport.push(dbPricingExpenses.wacData[0].quarterlyData[i]);
                    }
                }
                dataToExport.push("\n");
                dataToExport.push(["D Discount Discount $ Per Unit"] + " " + segKeyVal[segmentName]);
                for (var i = 0; i < (scenario.PBCQuarterInfoDates).length; i++) {
                    if (scenario.PBCQuarterInfoDates[i].Contract === 1) {
                        dataToExport.push(dbPricingExpenses.wacData[0].quarterlyData[i] - inputDetailsData.DiscountStructures[segmentName].Gnup.Data.deal.Quarterly[i]);
                    }
                }
                dataToExport.push("\n");
            } else if (inputDetailsData.DiscountStructures[segmentName].deal.selected === 'Discount/Rebate%') {
                dataToExport.push("\n D Discount/Rebate(%) - " + segKeyVal[segmentName], "\n");
                if (inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.BaseDiscount.IsIncluded.deal) {
                    dataToExport.push("\n D Discount  Base Discount - " + segKeyVal[segmentName], "Y \n");
                    dataToExport.push("\n D Discount Base Evaluation Method - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.BaseDiscount.EvaluationMethod.deal.selected, "\n");
                    dataToExport.push(["\n D Discount Base Metric - " + segKeyVal[segmentName]]);
                    for (var k = 0; k < months.length; k++) {
                        dataToExport.push(months[k]);
                    }
                    dataToExport.push(["\n D Discount Base Discount - " + segKeyVal[segmentName]]);
                    for (var k = 0; k < dates.length; k++) {
                        dataToExport.push(inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.BaseDiscount.Data.deal.Monthly[k]);
                    }
                    dataToExport.push("\n");
                }//to include wac per unit and discount dollar per unit if not included
                if (inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.IsIncluded.deal) {
                    dataToExport.push("\n D Discount Performance Based Discount/Rebate - " + segKeyVal[segmentName], "Y \n");

                    if (scenario.ScenarioSummary.PBCSummary.Source.selected === 'Facility') {
                        dataToExport.push("\n D Discount Performance Evaluation Level - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.EvaluationLevelsForFacility.deal.selected);
                    } else if (scenario.ScenarioSummary.PBCSummary.Source.selected === 'Account') {
                        dataToExport.push("\n D Discount Performance Evaluation Level - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.EvaluationLevelsForAccount.deal.selected);
                    } else if (scenario.ScenarioSummary.PBCSummary.Source.selected === 'Custom') {
                        dataToExport.push("\n D Discount Performance Evaluation Level - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.EvaluationLevelsForCustom.deal.selected);
                    }
                    dataToExport.push("\n D Discount Performance Performance Type - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.deal.selected);
                    if (inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.deal.selected === 'Absolute') {
                        dataToExport.push("\n D Discount Performance Performance Type Metric - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.Absolute.PerformanceTierBasedOn.deal.selected);
                    }
                    else if (inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.deal.selected === 'Growth') {
                        dataToExport.push("\n D Discount Performance Performance Type Metric - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.Growth.PerformanceTierBasedOn.deal.selected);
                    }

                    dataToExport.push("\nD Discount Performance Rebate Vs Discount - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.RebateOrDiscount.deal.selected);

                    dataToExport.push("\n");
                    dataToExport.push("\n D Discount Tier Classification - " + segKeyVal[segmentName], "\n");
                    dataToExport.push("\n D Discount Tier Selected UOM - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.UOM.deal.SelectedUOMText);
                    dataToExport.push("\n D Discount Tier Number Of Tiers - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.NumberOfTiers.deal);
                    dataToExport.push("\n D Discount Tier Evaluation Period Type - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.EvaluationPeriodType.deal.selected);
                    dataToExport.push("\n");
                    if (inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.deal.selected === 'Growth') {
                        if (inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.Growth.EvaluationBase.deal === 'Fixed') {
                            dataToExport.push("\n D Discount Tier Fixed Base - " + segKeyVal[segmentName]);
                            dataToExport.push("\n D Discount Tier Start Month - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.Growth.Fixed.StartMonth.deal.selected);
                            dataToExport.push("\n D Discount Tier End Month - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.Growth.Fixed.EndMonth.deal.selected);
                            dataToExport.push("\n D Discount Tier Evaluation Method - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.Growth.Fixed.EvaluationMethod.deal.selected);

                        } else if (inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.Growth.EvaluationBase.deal === 'Floating') {
                            dataToExport.push("\n D Discount Tier Floating Base - " + segKeyVal[segmentName]);
                            dataToExport.push("\n D Discount Tier Offset - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.Growth.Floating.Offset.deal);

                        }
                    }
                    dataToExport.push("\n");
                    if (inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Cohort.IsIncluded.deal) {
                        dataToExport.push("\n D Discount Cohort Classification - " + segKeyVal[segmentName], " Y \n");
                        if (source != 'Custom') {
                            var UOMText = inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Cohort.UOM.deal.options.filter(function (obj) {
                                return obj.UOM_Item == inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Cohort.UOM.deal.selected
                            })[0].UOM_Text;
                        } else {
                            var UOMText = inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Cohort.UOM.deal.selected;
                        }
                        dataToExport.push("\n D Discount Cohort Selected UOM - " + segKeyVal[segmentName], UOMText);
                        dataToExport.push("\n D Discount Cohort Number Of Thresholds - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Cohort.NumberOfThresholds.deal);
                        dataToExport.push("\n D Discount Cohort Threshold Based On - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Cohort.ThresholdBasedOn.deal);

                        dataToExport.push("\n Cohort Thresholds - " + segKeyVal[segmentName], "\n");
                        dataToExport.push("\n Cohort Thresholds - " + segKeyVal[segmentName]);
                        for (var l = 0; l < inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Cohort.Data.deal.length; l++) {
                            dataToExport.push(inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Cohort.Data.deal[l]);
                        }
                    }

                    dataToExport.push("\n");
                    dataToExport.push("\n D Discount Cohort Payment Lag - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Lag.deal);
                    dataToExport.push("\n D Discount Cohort Grace Discount - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.GraceDiscount.deal);

                    if (inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.RebateOrDiscount.deal.selected === 'Rebate') {
                        dataToExport.push("\n D Discount Cohort  Rebate Over - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.RebateOver.deal.selected);
                    }

                    dataToExport.push("\n");
                    dataToExport.push("\n D Discount Tiers - " + segKeyVal[segmentName], "\n");
                    dataToExport.push("D Discount Tiers Volume/Share tier threshold - " + segKeyVal[segmentName]);
                    for (var l = 0; l < inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.deal.Tier.length; l++) {
                        dataToExport.push(inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.deal.Tier[l]);
                    }


                    if (inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Cohort.IsIncluded.deal) {
                        dataToExport.push("\n");
                        dataToExport.push(inputDetailsData.cohortBucket.deal[0]);
                        for (var l = 0; l < inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.deal.Cohort1.length; l++) {
                            dataToExport.push(inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.deal.Cohort1[l]);
                        }
                        dataToExport.push("\n");
                        dataToExport.push(inputDetailsData.cohortBucket.deal[1]);
                        for (var l = 0; l < inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.deal.Cohort2.length; l++) {
                            dataToExport.push(inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.deal.Cohort2[l]);
                        }
                        dataToExport.push("\n");
                        dataToExport.push(inputDetailsData.cohortBucket.deal[2]);
                        for (var l = 0; l < inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.deal.Cohort3.length; l++) {
                            dataToExport.push(inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.deal.Cohort3[l]);
                        }
                        dataToExport.push("\n");
                        dataToExport.push(inputDetailsData.cohortBucket.deal[3]);
                        for (var l = 0; l < inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.deal.Cohort4.length; l++) {
                            dataToExport.push(inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.deal.Cohort4[l]);
                        }
                        dataToExport.push("\n");
                        dataToExport.push(inputDetailsData.cohortBucket.deal[4]);
                        for (var l = 0; l < inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.deal.Cohort5.length; l++) {
                            dataToExport.push(inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.deal.Cohort5[l]);
                        }
                        dataToExport.push("\n");
                        dataToExport.push(inputDetailsData.cohortBucket.deal[5]);
                        for (var l = 0; l < inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.deal.Cohort6.length; l++) {
                            dataToExport.push(inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.deal.Cohort6[l]);
                        }
                    } else {
                        dataToExport.push("\n");
                        dataToExport.push("D Discount  Discount/Rebate(%) - " + segKeyVal[segmentName]);
                        for (var l = 0; l < inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.deal.Values.length; l++) {
                            dataToExport.push(inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.deal.Values[l]);
                        }
                    }
                }

            }
            dataToExport.push("\n");

        });
        //Share Impact Assumptions
        dataToExport.push("\n D Share Impact Assumptions \n");
        for (var m = 0; m < scenarioDetails.SegmentImpacts.length; m++) {
            dataToExport.push("D ShareImpact Segment Name", scenarioDetails.SegmentImpacts[m].SegmentName, "\n");
            dataToExport.push(scenarioDetails.SegmentImpacts[m].SegmentName, "Market Share Cap (%)", "Peak Impact", "Exit Impact", "Source of Impact(%) \n");

            for (var n = 0; n < scenarioDetails.SegmentImpacts[m].PeakImpact.length; n++) {
                if (tempProduct.ProductLevel[n].IsIncluded &&
                    scenarioDetails.SegmentImpacts[m].PeakImpact[n].Product === tempProduct.ProductLevel[n].Name) {
                    if (n === 0) {
                        dataToExport.push(scenarioDetails.SegmentImpacts[m].PeakImpact[n].Product, scenarioDetails.SegmentImpacts[m].PeakImpact[n].deal.ShareCap, scenarioDetails.SegmentImpacts[m].PeakImpact[n].deal.PeakShareImpact, scenarioDetails.SegmentImpacts[m].PeakImpact[n].deal.ExitShareImpact, scenarioDetails.SegmentImpacts[m].PeakImpact[n].deal.SourceOfImpact, "\n");
                    } else {
                        dataToExport.push(scenarioDetails.SegmentImpacts[m].PeakImpact[n].Product,
                            "",
                            scenarioDetails.SegmentImpacts[m].PeakImpact[n].deal.PeakShareImpact,
                            scenarioDetails.SegmentImpacts[m].PeakImpact[n].deal.ExitShareImpact,
                            scenarioDetails.SegmentImpacts[m].PeakImpact[n].deal.SourceOfImpact,
                            "\n");
                    }
                }
            }
        }
        //Share Impact Adoption curve section
        dataToExport.push("\n");
        dataToExport.push("\n D ShareImpact Adoption Curve \n");
        dataToExport.push("Segment");
        for (var k = 0; k < adoptionCurveQuarter.length; k++) {
            dataToExport.push(adoptionCurveQuarter[k]);
        }
        dataToExport.push("\n");
        for (var m = 0; m < scenarioDetails.SegmentImpacts.length; m++) {
            dataToExport.push(scenarioDetails.SegmentImpacts[m].SegmentName);
            for (var k = 0; k < adoptionCurveQuarter.length; k++) {
                //if (scenario.PBCQuarterInfoDates[k].Contract === 1) {
                dataToExport.push(scenarioDetails.SegmentImpacts[m].AdoptionCurve[0].deal.quarterlyData[k]);
                //}
            }
            dataToExport.push("\n");

        }
        dataToExport.push("\n");
        dataToExport.push("\n");
        //No Deal Section
        //Admin Fees
        dataToExport.push("\nNo Deal \n");
        segmentList.forEach((val, segmentIndex) => {
            var segmentName: any = segmentList[segmentIndex].SegmentName;
            dataToExport.push("\n Segment : " + segmentName + " \n");
            if (inputDetailsData.AdminFees[segmentName].Flat.IsIncluded.noDeal) {
                dataToExport.push("\n ND Flat Admin Fees - " + segKeyVal[segmentName], "Y \n");
                dataToExport.push("\n ND Admin Fee Evaluation Method - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].Flat.EvaluationMethod.noDeal.selected, "\n");
                dataToExport.push(["\n ND Admin Fee Metric - " + segKeyVal[segmentName]]);
                for (var k = 0; k < months.length; k++) {
                    dataToExport.push(months[k]);
                }
                dataToExport.push(["\n ND Admin Fees - " + segKeyVal[segmentName]]);
                for (var k = 0; k < dates.length; k++) {
                    dataToExport.push(inputDetailsData.AdminFees[segmentName].Flat.Data.noDeal.Monthly[k]);
                }
                dataToExport.push("\n");
            }
            if (inputDetailsData.AdminFees[segmentName].PerformanceBased.IsIncluded.noDeal) {

                dataToExport.push("\n ND Performance Based Admin Fees - " + segKeyVal[segmentName], "Y \n");
                dataToExport.push("\n ND Performance Level To Apply - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.LevelToApply.noDeal.selected);
                if (scenario.ScenarioSummary.PBCSummary.Source.selected === 'Facility') {
                    dataToExport.push("\n ND Performance Evaluation Level - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.EvaluationLevelsForFacility.noDeal.selected);
                } else if (scenario.ScenarioSummary.PBCSummary.Source.selected === 'Account') {
                    dataToExport.push("\n ND Performance Evaluation Level - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.EvaluationLevelsForAccount.noDeal.selected);
                } else if (scenario.ScenarioSummary.PBCSummary.Source.selected === 'Custom') {
                    dataToExport.push("\n ND Performance Evaluation Level - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.EvaluationLevelsForCustom.noDeal.selected);
                }
                dataToExport.push("\n ND Performance Type - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.noDeal.selected);
                if (inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.noDeal.selected === 'Absolute') {
                    dataToExport.push("\n ND Performance Type Metric - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.Absolute.PerformanceTierBasedOn.noDeal.selected);
                }
                else if (inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.noDeal.selected === 'Growth') {
                    dataToExport.push("\n ND Performance Type Metric - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.Growth.PerformanceTierBasedOn.noDeal.selected);
                }
                dataToExport.push("\n");
                dataToExport.push("\n ND Performance Tier Classification - " + segKeyVal[segmentName], "\n");
                dataToExport.push("\n ND Performance Tier Selected UOM - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.UOM.noDeal.SelectedUOMText);
                dataToExport.push("\n ND Performance Tier Number Of Tiers - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.NumberOfTiers.noDeal);
                dataToExport.push("\n ND Performance Tier Evaluation Period Type - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.EvaluationPeriodType.noDeal.selected);
                dataToExport.push("\n");
                if (inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.noDeal.selected === 'Growth') {
                    if (inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.Growth.EvaluationBase.noDeal === 'Fixed') {
                        dataToExport.push("\n ND Performance Tier Fixed Base - " + segKeyVal[segmentName]);
                        dataToExport.push("\n ND Performance Tier Start Month - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.Growth.Fixed.StartMonth.noDeal.selected);
                        dataToExport.push("\n ND Performance Tier End Month - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.Growth.Fixed.EndMonth.noDeal.selected);
                        dataToExport.push("\n ND Performance Tier Evaluation Method - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.Growth.Fixed.EvaluationMethod.noDeal.selected);

                    } else if (inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.Growth.EvaluationBase.noDeal === 'Floating') {
                        dataToExport.push("\nND Performance Tier Floating Base - " + segKeyVal[segmentName]);
                        dataToExport.push("\n ND Performance Tier Offset - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.PerformanceType.Growth.Floating.Offset.noDeal);

                    }
                }
                dataToExport.push("\n");
                dataToExport.push("\n ND Performance Tier Admin Fee Lag - " + segKeyVal[segmentName], inputDetailsData.AdminFees[segmentName].PerformanceBased.Lag.noDeal);
                dataToExport.push("\n");
                dataToExport.push("\n ND Admin Fee Tiers - " + segKeyVal[segmentName], "\n");
                dataToExport.push("\n ND Admin Fee Tier Volume/Share tier threshold - " + segKeyVal[segmentName]);
                for (var l = 0; l < inputDetailsData.AdminFees[segmentName].PerformanceBased.Data.noDeal.Tiers.length; l++) {
                    dataToExport.push(inputDetailsData.AdminFees[segmentName].PerformanceBased.Data.noDeal.Tiers[l]);
                }
                dataToExport.push("\n ND Performance Tier Admin Fee(%) - " + segKeyVal[segmentName]);
                for (var l = 0; l < inputDetailsData.AdminFees[segmentName].PerformanceBased.Data.noDeal.Values.length; l++) {
                    dataToExport.push(inputDetailsData.AdminFees[segmentName].PerformanceBased.Data.noDeal.Values[l]);
                }
            }
            dataToExport.push("\n");
            //Discount Structures
            if (inputDetailsData.DiscountStructures[segmentName].noDeal.selected === 'GNUP') {
                dataToExport.push("\n ND Discount GNUP - " + segKeyVal[segmentName], "\n");
                dataToExport.push(["ND Discount Metric - " + segKeyVal[segmentName]]);
                for (var k = 0; k < contractQuarters.length; k++) {
                    dataToExport.push(contractQuarters[k]);
                }
                dataToExport.push("\n");
                dataToExport.push(["ND Discount Net Unit Price - " + segKeyVal[segmentName]]);
                for (var k = 0; k < quarters.length; k++) {
                    if (scenario.PBCQuarterInfoDates[k].Contract === 1) {
                        dataToExport.push(inputDetailsData.DiscountStructures[segmentName].Gnup.Data.noDeal.Quarterly[k]);
                    }
                }
                dataToExport.push("\n");
                dataToExport.push(["ND Discount WAC Per Unit - " + segKeyVal[segmentName]]);
                for (var i = 0; i < (scenario.PBCQuarterInfoDates).length; i++) {
                    if (scenario.PBCQuarterInfoDates[i].Contract === 1) {
                        dataToExport.push(dbPricingExpenses.wacData[0].quarterlyData[i]);
                    }
                }
                dataToExport.push("\n");
                dataToExport.push(["ND Discount Discount $ Per Unit - " + segKeyVal[segmentName]]);
                for (var i = 0; i < (scenario.PBCQuarterInfoDates).length; i++) {
                    if (scenario.PBCQuarterInfoDates[i].Contract === 1) {
                        dataToExport.push(dbPricingExpenses.wacData[0].quarterlyData[i] - inputDetailsData.DiscountStructures[segmentName].Gnup.Data.noDeal.Quarterly[i]);
                    }
                }
                dataToExport.push("\n");
            } else if (inputDetailsData.DiscountStructures[segmentName].noDeal.selected === 'Discount/Rebate%') {
                dataToExport.push("\n ND Discount Discount/Rebate(%) - " + segKeyVal[segmentName], "\n");
                if (inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.BaseDiscount.IsIncluded.noDeal) {
                    dataToExport.push("\n ND Discount  Base Discount - " + segKeyVal[segmentName], "Y \n");
                    dataToExport.push("\n ND Discount  Base Evaluation Method - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.BaseDiscount.EvaluationMethod.noDeal.selected, "\n");
                    dataToExport.push(["\n ND Discount Base Metric - " + segKeyVal[segmentName]]);
                    for (var k = 0; k < months.length; k++) {
                        dataToExport.push(months[k]);
                    }
                    dataToExport.push(["\n ND Discount Base Discount - " + segKeyVal[segmentName]]);
                    for (var k = 0; k < dates.length; k++) {
                        dataToExport.push(inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.BaseDiscount.Data.noDeal.Monthly[k]);
                    }
                    dataToExport.push("\n");
                }
                if (inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.IsIncluded.noDeal) {
                    dataToExport.push("\n ND Performance Based Discount/Rebate - " + segKeyVal[segmentName], "Y \n");

                    if (scenario.ScenarioSummary.PBCSummary.Source.selected === 'Facility') {
                        dataToExport.push("\n ND Discount Performance Evaluation Level - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.EvaluationLevelsForFacility.noDeal.selected);
                    } else if (scenario.ScenarioSummary.PBCSummary.Source.selected === 'Account') {
                        dataToExport.push("\n ND Discount Performance Evaluation Level - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.EvaluationLevelsForAccount.noDeal.selected);
                    } else if (scenario.ScenarioSummary.PBCSummary.Source.selected === 'Custom') {
                        dataToExport.push("\n ND Discount Performance Evaluation Level - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.EvaluationLevelsForCustom.noDeal.selected);
                    }
                    dataToExport.push("\n ND Discount Performance Performance Type - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.noDeal.selected);
                    if (inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.noDeal.selected === 'Absolute') {
                        dataToExport.push("\n ND Discount Performance Performance Type Metric - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.Absolute.PerformanceTierBasedOn.noDeal.selected);
                    }
                    else if (inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.noDeal.selected === 'Growth') {
                        dataToExport.push("\n ND Discount Performance Performance Type Metric - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.Growth.PerformanceTierBasedOn.noDeal.selected);
                    }

                    dataToExport.push("\n ND Discount PerformanceRebate Vs Discount - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.RebateOrDiscount.noDeal.selected);

                    dataToExport.push("\n");
                    dataToExport.push("\n  ND Discount Tier Classification - " + segKeyVal[segmentName], "\n");
                    dataToExport.push("\n ND Discount Tier Selected UOM - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.UOM.noDeal.SelectedUOMText);
                    dataToExport.push("\n ND Discount Tier Number Of Tiers - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.NumberOfTiers.noDeal);
                    dataToExport.push("\n ND Discount Tier Evaluation Period Type - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.EvaluationPeriodType.noDeal.selected);
                    dataToExport.push("\n");
                    if (inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.noDeal.selected === 'Growth') {
                        if (inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.Growth.EvaluationBase.noDeal === 'Fixed') {
                            dataToExport.push("\n ND Discount Tier Fixed Base - " + segKeyVal[segmentName]);
                            dataToExport.push("\n ND Discount Tier Start Month - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.Growth.Fixed.StartMonth.noDeal.selected);
                            dataToExport.push("\n ND Discount Tier End Month - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.Growth.Fixed.EndMonth.noDeal.selected);
                            dataToExport.push("\n ND Discount Tier Evaluation Method - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.Growth.Fixed.EvaluationMethod.noDeal.selected);

                        } else if (inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.Growth.EvaluationBase.noDeal === 'Floating') {
                            dataToExport.push("\n ND Discount Tier Floating Base - " + segKeyVal[segmentName]);
                            dataToExport.push("\n ND Discount Tier Offset - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.PerformanceType.Growth.Floating.Offset.noDeal);

                        }
                    }
                    dataToExport.push("\n");
                    if (inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Cohort.IsIncluded.noDeal) {
                        dataToExport.push("\n ND Discount Cohort Classification - " + segKeyVal[segmentName], " Y \n");
                        if (source != 'Custom') {
                            var UOMText = inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Cohort.UOM.noDeal.options.filter(function (obj) {
                                return obj.UOM_Item == inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Cohort.UOM.noDeal.selected
                            })[0].UOM_Text;
                        } else {
                            var UOMText = inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Cohort.UOM.noDeal.selected;
                        }
                        dataToExport.push("\n ND Discount Cohort Selected UOM - " + segKeyVal[segmentName], UOMText);
                        dataToExport.push("\n ND Discount Cohort Number Of Thresholds - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Cohort.NumberOfThresholds.noDeal);
                        dataToExport.push("\n ND Discount Cohort Threshold Based On - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Cohort.ThresholdBasedOn.noDeal);

                        dataToExport.push("\n Cohort Thresholds - " + segKeyVal[segmentName], "\n");
                        dataToExport.push("\n Cohort Thresholds - " + segKeyVal[segmentName]);
                        for (var l = 0; l < inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Cohort.Data.noDeal.length; l++) {
                            dataToExport.push(inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Cohort.Data.noDeal[l]);
                        }
                    }

                    dataToExport.push("\n");
                    dataToExport.push("\n ND Discount Cohort Payment Lag - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Lag.noDeal);
                    dataToExport.push("\n ND Discount Cohort Grace Discount - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.GraceDiscount.noDeal);

                    if (inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.RebateOrDiscount.noDeal.selected === 'Rebate') {
                        dataToExport.push("\n ND Discount Cohort Rebate Over - " + segKeyVal[segmentName], inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.RebateOver.noDeal.selected);
                    }

                    dataToExport.push("\n");
                    dataToExport.push("\n ND Discount Tiers - " + segKeyVal[segmentName], "\n");
                    dataToExport.push("ND Discount Tiers Volume/Share tier threshold - " + segKeyVal[segmentName]);
                    for (var l = 0; l < inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.noDeal.Tier.length; l++) {
                        dataToExport.push(inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.noDeal.Tier[l]);
                    }


                    if (inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Cohort.IsIncluded.noDeal) {
                        dataToExport.push("\n");
                        dataToExport.push(inputDetailsData.cohortBucket.noDeal[0]);
                        for (var l = 0; l < inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.noDeal.Cohort1.length; l++) {
                            dataToExport.push(inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.noDeal.Cohort1[l]);
                        }
                        dataToExport.push("\n");
                        dataToExport.push(inputDetailsData.cohortBucket.noDeal[1]);
                        for (var l = 0; l < inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.noDeal.Cohort2.length; l++) {
                            dataToExport.push(inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.noDeal.Cohort2[l]);
                        }
                        dataToExport.push("\n");
                        dataToExport.push(inputDetailsData.cohortBucket.noDeal[2]);
                        for (var l = 0; l < inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.noDeal.Cohort3.length; l++) {
                            dataToExport.push(inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.noDeal.Cohort3[l]);
                        }
                        dataToExport.push("\n");
                        dataToExport.push(inputDetailsData.cohortBucket.noDeal[3]);
                        for (var l = 0; l < inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.noDeal.Cohort4.length; l++) {
                            dataToExport.push(inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.noDeal.Cohort4[l]);
                        }
                        dataToExport.push("\n");
                        dataToExport.push(inputDetailsData.cohortBucket.noDeal[4]);
                        for (var l = 0; l < inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.noDeal.Cohort5.length; l++) {
                            dataToExport.push(inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.noDeal.Cohort5[l]);
                        }
                        dataToExport.push("\n");
                        dataToExport.push(inputDetailsData.cohortBucket.noDeal[5]);
                        for (var l = 0; l < inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.noDeal.Cohort6.length; l++) {
                            dataToExport.push(inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.noDeal.Cohort6[l]);
                        }
                    } else {
                        dataToExport.push("\n");
                        dataToExport.push("ND Discount Discount/Rebate(%) - " + segKeyVal[segmentName]);
                        for (var l = 0; l < inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.noDeal.Values.length; l++) {
                            dataToExport.push(inputDetailsData.DiscountStructures[segmentName].DiscountOrRebate.PerformanceBased.Data.noDeal.Values[l]);
                        }
                    }
                }

            }
            dataToExport.push("\n");
        });
        //Share Impact Assumptions
        dataToExport.push("\n ND Share Impact Assumptions \n");
        for (var m = 0; m < scenarioDetails.SegmentImpacts.length; m++) {
            dataToExport.push("ND ShareImpact Segment Name", scenarioDetails.SegmentImpacts[m].SegmentName, "\n");
            dataToExport.push(scenarioDetails.SegmentImpacts[m].SegmentName,
                "Market Share Cap (%)",
                "Peak Impact",
                "Exit Impact",
                "Source of Impact(%) \n");

            for (var n = 0; n < scenarioDetails.SegmentImpacts[m].PeakImpact.length; n++) {
                if (tempProduct.ProductLevel[n].IsIncluded &&
                    scenarioDetails.SegmentImpacts[m].PeakImpact[n].Product === tempProduct.ProductLevel[n].Name) {
                    if (n === 0) {
                        dataToExport.push(scenarioDetails.SegmentImpacts[m].PeakImpact[n].Product,
                            scenarioDetails.SegmentImpacts[m].PeakImpact[n].noDeal.ShareCap,
                            scenarioDetails.SegmentImpacts[m].PeakImpact[n].noDeal.PeakShareImpact,
                            scenarioDetails.SegmentImpacts[m].PeakImpact[n].noDeal.ExitShareImpact,
                            scenarioDetails.SegmentImpacts[m].PeakImpact[n].noDeal.SourceOfImpact,
                            "\n");

                    } else {
                        dataToExport.push(scenarioDetails.SegmentImpacts[m].PeakImpact[n].Product,
                            "",
                            scenarioDetails.SegmentImpacts[m].PeakImpact[n].noDeal.PeakShareImpact,
                            scenarioDetails.SegmentImpacts[m].PeakImpact[n].noDeal.ExitShareImpact,
                            scenarioDetails.SegmentImpacts[m].PeakImpact[n].noDeal.SourceOfImpact,
                            "\n");
                    }
                }
            }
        }
        //Share Impact Adoption Curve
        dataToExport.push("\n");
        dataToExport.push("\n ND ShareImpact Adoption Curve \n");
        dataToExport.push("Segment");
        for (var k = 0; k < adoptionCurveQuarter.length; k++) {
            dataToExport.push(adoptionCurveQuarter[k]);
        }
        dataToExport.push("\n");
        for (var m = 0; m < scenarioDetails.SegmentImpacts.length; m++) {
            dataToExport.push(scenarioDetails.SegmentImpacts[m].SegmentName);
            for (var k = 0; k < adoptionCurveQuarter.length; k++) {
                //if (scenario.PBCQuarterInfoDates[k].Contract === 1) {
                dataToExport.push(scenarioDetails.SegmentImpacts[m].AdoptionCurve[0].noDeal.quarterlyData[k]);
                //}
            }
            dataToExport.push("\n");
        }
        dataToExport.push("\n");
        dataToExport.push("\n Contract Expectations\n");
        dataToExport.push("\n ContractExp Share" + "\n");
        dataToExport.push("Segment", "Metric", "Deal", "", "No Deal", "");
        dataToExport.push("\n");
        dataToExport.push("", "Product", "Baseline Exit Share", "Exit Share", "Baseline Exit Share", "Exit Share");
        dataToExport.push("\n");
        var segNumberLabel = 1;
        for (let key in contractExpectationsSummary) {
            if (key == 'Overall') {
                segNumberLabel = 0;
            } else {
                segNumberLabel = segKeyVal[key];
            }

            for (var o = 0; o < contractExpectationsSummary[key].summaryData.ExitTRxShare.length; o++) {
                dataToExport.push(segNumberLabel, contractExpectationsSummary[key].summaryData.ExitTRxShare[o].Product, contractExpectationsSummary[key].summaryData.ExitTRxShare[o].deal.baseline.TrX.Share, contractExpectationsSummary[key].summaryData.ExitTRxShare[o].deal.exit.TrX.Share, contractExpectationsSummary[key].summaryData.ExitTRxShare[o].noDeal.baseline.TrX.Share, contractExpectationsSummary[key].summaryData.ExitTRxShare[o].noDeal.exit.TrX.Share);
                dataToExport.push("\n");
            }

        }
        dataToExport.push("\n");
        dataToExport.push("\n ContractExp Volume \n");
        dataToExport.push("Segment", "Metric", "Deal", "", "No Deal", "");
        dataToExport.push("\n");
        dataToExport.push("", "Product", "Baseline Exit Volume", "Exit Volume", "Baseline Exit Volume", "Exit Volume");
        dataToExport.push("\n");
        for (let key in contractExpectationsSummary) {
            if (key == 'Overall') {
                segNumberLabel = 0;
            } else {
                segNumberLabel = segKeyVal[key];
            }
            for (var o = 0; o < contractExpectationsSummary[key].summaryData.ExitTRxShare.length; o++) {
                dataToExport.push(segNumberLabel, contractExpectationsSummary[key].summaryData.ExitTRxShare[o].Product, contractExpectationsSummary[key].summaryData.ExitTRxShare[o].deal.baseline.TrX.Volume, contractExpectationsSummary[key].summaryData.ExitTRxShare[o].deal.exit.TrX.Volume, contractExpectationsSummary[key].summaryData.ExitTRxShare[o].noDeal.baseline.TrX.Volume, contractExpectationsSummary[key].summaryData.ExitTRxShare[o].noDeal.exit.TrX.Volume);
                dataToExport.push("\n");
            }
        }

        dataToExport.push("\n");

        dataToExport.push("\n Deal Financials \n");
        dataToExport.push("Segment");
        dataToExport.push("Metric");

        for (var p = 0; p < months.length; p++) {
            dataToExport.push(months[p]);
        }
        dataToExport.push("\n");
        //segmentList.forEach((val,segmentIndex) => {
        for (let segKey in financialConfiguration) {
            if (segmentList.length <= 1 && segKey == 'overAll') {

            } else {
                var segmentName: any = segKey;


                for (var q = 0; q < financialConfiguration[segmentName][0].data.length; q++) {
                    if ((financialConfiguration[segmentName][0].data[q].Line_Item === "MandatedRebatesPercent" || financialConfiguration[segmentName][0].data[q].Line_Item === 'MandatedRebates') && (inputDetailsData.IncludeMandateRebate) !== true) {
                        continue;
                    }
                    dataToExport.push(segKeyVal[segmentName]);
                    dataToExport.push(financialConfiguration[segmentName][0].data[q].Item_Text);
                    for (var k = 0; k < months.length; k++) {
                        dataToExport.push(financialConfiguration[segmentName][0].data[q].data.deal[0].data[k]);
                    }
                    dataToExport.push("\n");

                }
            }

        }

        dataToExport.push("\nNo Deal Financials \n");
        dataToExport.push("Segment");
        dataToExport.push("Metric");
        for (var p = 0; p < months.length; p++) {
            dataToExport.push(months[p]);
        }
        dataToExport.push("\n");
        //segmentList.forEach((val,segmentIndex) => {
        for (let segKey in financialConfiguration) {
            if (segmentList.length <= 1 && segKey == 'overAll') {

            } else {

                var segmentName: any = segKey;




                for (var q = 0; q < financialConfiguration[segmentName][0].data.length; q++) {

                    if ((financialConfiguration[segmentName][0].data[q].Line_Item === "MandatedRebatesPercent" || financialConfiguration[segmentName][0].data[q].Line_Item === 'MandatedRebates') && (inputDetailsData.IncludeMandateRebate) !== true) {
                        continue;
                    }
                    dataToExport.push(segKeyVal[segmentName]);
                    dataToExport.push(financialConfiguration[segmentName][0].data[q].Item_Text);
                    for (var k = 0; k < months.length; k++) {
                        dataToExport.push(financialConfiguration[segmentName][0].data[q].data.noDeal[0].data[k]);
                    }
                    dataToExport.push("\n");
                }
                //dataToExport.push("\n");
                //});
            }
        }
        dataToExport.push("\n return On Contract\n");

        dataToExport.push("Segment", "ROC");
        dataToExport.push("\n");
        //segmentList.forEach((val,segmentIndex) => {
        for (let segKey in returnOnContract[0].data) {
            if (Object.keys(returnOnContract[0].data).length <= 1 && segKey == 'overAll') {

            } else {
                var segmentName: any = segKey;
                dataToExport.push(segKeyVal[segmentName]);
                dataToExport.push(returnOnContract[0].data[segmentName].brandReturnOnContract);
                dataToExport.push("\n");
                //});
            }
        }

        dataToExport.push("\n Global Inputs WAC Pricing \n");
        dataToExport.push("WAC Pricing");
        for (var k = 0; k < months.length; k++) {
            dataToExport.push(months[k]);
        }
        dataToExport.push("\n");
        if (source != 'Custom') {
            for (var i = 0; i < dbPricingExpenses.wacData.length; i++) {
                if (dbPricingExpenses.wacData[i].Key === tempProduct.ProductLevel[i].Name && tempProduct.ProductLevel[i].IsIncluded) {
                    dataToExport.push(dbPricingExpenses.wacData[i].Key);
                    for (var j = 0; j < dbPricingExpenses.wacData[0].Value.length; j++) {
                        dataToExport.push(dbPricingExpenses.wacData[i].Value[j].WAC_Unit);
                    }
                    dataToExport.push("\n");
                }
            }
        } else {
            //NQ- in case of custom, dbPricingExpenses does not contain Key like Account and Facility flow. Using tempProduct to see if it is contained in the market basket
            //NQ- The code for account, facility and custom can be merged into one--> the below piece of code should work with all three flows
            for (var i = 0; i < dbPricingExpenses.wacData.length; i++) {
                if (tempProduct.ProductLevel[i].IsIncluded) {
                    dataToExport.push(tempProduct.ProductLevel[i].Name);
                    for (var j = 0; j < dbPricingExpenses.wacData[0].Value.length; j++) {
                        dataToExport.push(dbPricingExpenses.wacData[i].Value[j].WAC_Unit);
                    }
                    dataToExport.push("\n");
                }
            }
        }
        if (source != 'Custom') {
            dataToExport.push("\nGlobal Inputs National Forecast \n");
            dataToExport.push("National Forecast");
            for (var k = 0; k < months.length; k++) {
                dataToExport.push(months[k]);
            }
            dataToExport.push("\n");
            for (var i = 0; i < nationalForecastData.length; i++) {
                if (nationalForecastData[i].Key === tempProduct.ProductLevel[i].Name && tempProduct.ProductLevel[i].IsIncluded) {
                    dataToExport.push(nationalForecastData[i].Key);
                    for (var j = 0; j < nationalForecastData[0].Value.length; j++) {
                        dataToExport.push(nationalForecastData[i].Value[j][inputDetailsData.SelectedUOM]);
                    }
                    dataToExport.push("\n");
                }
            }
        }


        dataToExport.push("\n ASP Summary \n");
        dataToExport.push("\t");
        for (var k = 0; k < contractQuarters.length; k++) {
            dataToExport.push(contractQuarters[k]);
        }
        dataToExport.push("\n");
        dataToExport.push("WAC");
        for (var i = 0; i < (scenario.PBCQuarterInfoDates).length; i++) {
            if (scenario.PBCQuarterInfoDates[i].Contract === 1) {
                dataToExport.push(aspSummary.WAC.quarterlyData[i]);
            }
        }
        dataToExport.push("\n");
        dataToExport.push("Baseline ASP");
        for (var i = 0; i < (scenario.PBCQuarterInfoDates).length; i++) {
            if (scenario.PBCQuarterInfoDates[i].Contract === 1) {
                dataToExport.push(aspSummary.baseline.quarterlyData[i]);
            }
        }
        dataToExport.push("\n");
        dataToExport.push("Deal ASP");
        for (var i = 0; i < (scenario.PBCQuarterInfoDates).length; i++) {
            if (scenario.PBCQuarterInfoDates[i].Contract === 1) {
                dataToExport.push(aspSummary.deal.quarterlyData[i]);
            }
        }
        dataToExport.push("\n");
        dataToExport.push("No Deal ASP ");
        for (var i = 0; i < (scenario.PBCQuarterInfoDates).length; i++) {
            if (scenario.PBCQuarterInfoDates[i].Contract === 1) {
                dataToExport.push(aspSummary.noDeal.quarterlyData[i]);
            }
        }
        dataToExport.push("\n");

        //customer POV

        dataToExport.push("\n Customer POV \n");
        dataToExport.push("\n Deal Customer POV \n");
        dataToExport.push("Segment", "Product", "Metric ");
        for (var p = 0; p < months.length; p++) {
            dataToExport.push(months[p]);
        }
        dataToExport.push("\n");

        //segment level
        for (let s in segCustomerPOV) {
            for (var product in segCustomerPOV[s]) {
                for (var lineItem in segCustomerPOV[s][product]) {
                    if (s != 'Overall') {
                        dataToExport.push(segKeyVal[s]);
                    } else {
                        dataToExport.push(segKeyVal['overAll']);
                    }
                    dataToExport.push(product);
                    dataToExport.push(lineItem);
                    for (var m = 0; m < segCustomerPOV[s][product][lineItem].monthlyData.deal.length; m++) {
                        dataToExport.push(segCustomerPOV[s][product][lineItem].monthlyData.deal[m]);
                    }
                    dataToExport.push("\n");
                }
            }
        }

        dataToExport.push("\nNoDeal Customer POV\n");
        dataToExport.push("Segment", "Product", "Metric");
        for (var p = 0; p < months.length; p++) {
            dataToExport.push(months[p]);
        }
        dataToExport.push("\n");

        //segment level
        for (let s in segCustomerPOV) {
            for (var product in segCustomerPOV[s]) {
                for (var lineItem in segCustomerPOV[s][product]) {
                    if (s != 'Overall') {
                        dataToExport.push(segKeyVal[s]);
                    } else {
                        dataToExport.push(segKeyVal['overAll']);
                    }
                    dataToExport.push(product);
                    dataToExport.push(lineItem);
                    for (var m = 0; m < segCustomerPOV[s][product][lineItem].monthlyData.noDeal.length; m++) {
                        dataToExport.push(segCustomerPOV[s][product][lineItem].monthlyData.noDeal[m]);
                    }
                    dataToExport.push("\n");
                }
            }
        }

        dataToExport.push("\n Financial Inputs \n");
        dataToExport.push("Metrics", "Product");

        for (var p = 0; p < months.length; p++) {
            dataToExport.push(months[p]);
        }
        dataToExport.push("\n");
        dataToExport.push("Cogs");
        dataToExport.push(customerPOVPBCConfiguration[0].Product);
        for (var j = 0; j < dbPricingExpenses.expensesData[0].Value.length; j++) {
            dataToExport.push(dbPricingExpenses.expensesData[0].Value[j].Cogs);
        }
        dataToExport.push("\n");
        dataToExport.push("Commision");
        dataToExport.push(customerPOVPBCConfiguration[0].Product);
        for (var j = 0; j < dbPricingExpenses.expensesData[0].Value.length; j++) {
            dataToExport.push(dbPricingExpenses.expensesData[0].Value[j].Commision);
        }
        dataToExport.push("\n");
        dataToExport.push("Distribution Costs");
        dataToExport.push(customerPOVPBCConfiguration[0].Product);
        for (var j = 0; j < dbPricingExpenses.expensesData[0].Value.length; j++) {
            dataToExport.push(dbPricingExpenses.expensesData[0].Value[j].Distribution_Costs);
        }
        dataToExport.push("\n");
        dataToExport.push("Royalties");
        dataToExport.push(customerPOVPBCConfiguration[0].Product);
        for (var j = 0; j < dbPricingExpenses.expensesData[0].Value.length; j++) {
            dataToExport.push(dbPricingExpenses.expensesData[0].Value[j].Royalties);
        }

        dataToExport.push("\n \n");
        dataToExport.push("\nNotes Section \n");
        dataToExport.push("Notes\n");
        dataToExport.push(scenario.ScenarioSummary.Notes);

        dataToExport.push("\nSegment name to number mapping\n");
        var i = 1;
        dataToExport.push("Number", "Segment Name");
        dataToExport.push("\n");
        for (let s in segCustomerPOV) {
            if (s == 'Overall') {
                i = 0;
            }
            dataToExport.push(i, s);
            i = i + 1;
            dataToExport.push('\n');
        }

        return dataToExport;
    }

    convertCustomerPOVToReqForm = function (customerPOVPBCConfiguration, reqForm, providerPoVDdb, dates) {
        var filterArray = [];
        var returnJson = {};
        if (reqForm == 'segment') {
            filterArray = providerPoVDdb.segment.options;
        } else if (reqForm == 'CorporateParent') {
            filterArray = providerPoVDdb.corporateParent.options;
        } else if (reqForm == 'Facility') {
            filterArray = providerPoVDdb.facility.options;
        }
        var divisionFactor = 1;
        //initialization
        for (var j = 0; j < filterArray.length; j++) {
            returnJson[filterArray[j]] = {};
            for (var p = 0; p < customerPOVPBCConfiguration.length; p++) {
                returnJson[filterArray[j]][customerPOVPBCConfiguration[p].Product] = {};
                for (var i = 0; i < customerPOVPBCConfiguration[0].data.length; i++) {
                    returnJson[filterArray[j]][customerPOVPBCConfiguration[p].Product][customerPOVPBCConfiguration[0].data[i].Line_Item] = { Scale: customerPOVPBCConfiguration[0].data[i].Scale, Visible: customerPOVPBCConfiguration[0].data[i].Visible, monthlyData: { deal: [], noDeal: [], delta: [] } };
                    for (var m = 0; m < dates.length; m++) {
                        returnJson[filterArray[j]][customerPOVPBCConfiguration[p].Product][customerPOVPBCConfiguration[0].data[i].Line_Item].monthlyData.deal.push(0);
                        returnJson[filterArray[j]][customerPOVPBCConfiguration[p].Product][customerPOVPBCConfiguration[0].data[i].Line_Item].monthlyData.noDeal.push(0);
                        returnJson[filterArray[j]][customerPOVPBCConfiguration[p].Product][customerPOVPBCConfiguration[0].data[i].Line_Item].monthlyData.delta.push(0);
                    }
                }
            }
        }


        for (var i = 0; i < customerPOVPBCConfiguration.length; i++) {
            for (var j = 0; j < filterArray.length; j++) {
                if (reqForm == 'CorporateParent') {
                    var filteredData = customerPOVPBCConfiguration[i].ByFacility.filter(function (obj) { return obj.Corporate_Parent_Name == filterArray[j] });
                } else if (reqForm == 'segment') {
                    var filteredData = customerPOVPBCConfiguration[i].ByFacility.filter(function (obj) { return obj.segment == filterArray[j] });
                } else if (reqForm == 'Facility') {
                    var filteredData = customerPOVPBCConfiguration[i].ByFacility.filter(function (obj) { return obj.Facility_Name == filterArray[j] });
                }
                for (var d = 0; d < filteredData[0].data.length; d++) {
                    for (var f = 0; f < filteredData.length; f++) {
                        if (returnJson[filterArray[j]][customerPOVPBCConfiguration[i].Product][filteredData[f].data[d].Line_Item].Scale == 'Thousands') {
                            // divisionFactor = 1000;
                        }
                        for (var m = 0; m < dates.length; m++) {
                            returnJson[filterArray[j]][customerPOVPBCConfiguration[i].Product][filteredData[f].data[d].Line_Item].monthlyData.deal[m] += parseFloat(filteredData[f].data[d].data.deal[0].data[m]) / divisionFactor;
                            returnJson[filterArray[j]][customerPOVPBCConfiguration[i].Product][filteredData[f].data[d].Line_Item].monthlyData.noDeal[m] += parseFloat(filteredData[f].data[d].data.noDeal[0].data[m]) / divisionFactor;
                            returnJson[filterArray[j]][customerPOVPBCConfiguration[i].Product][filteredData[f].data[d].Line_Item].monthlyData.delta[m] += parseFloat(filteredData[f].data[d].data.delta[0].data[m]) / divisionFactor;
                        }
                    }
                }
            }
        }
        if (filterArray.length > 1) {
            returnJson['Overall'] = {};
            for (var p = 0; p < customerPOVPBCConfiguration.length; p++) {
                returnJson['Overall'][customerPOVPBCConfiguration[p].Product] = {};
                for (var i = 0; i < customerPOVPBCConfiguration[0].data.length; i++) {
                    returnJson['Overall'][customerPOVPBCConfiguration[p].Product][customerPOVPBCConfiguration[0].data[i].Line_Item] = { Scale: customerPOVPBCConfiguration[0].data[i].Scale, Visible: customerPOVPBCConfiguration[0].data[i].Visible, monthlyData: { deal: [], noDeal: [], delta: [] } };
                    for (var m = 0; m < dates.length; m++) {
                        returnJson['Overall'][customerPOVPBCConfiguration[p].Product][customerPOVPBCConfiguration[0].data[i].Line_Item].monthlyData.deal.push(0);
                        returnJson['Overall'][customerPOVPBCConfiguration[p].Product][customerPOVPBCConfiguration[0].data[i].Line_Item].monthlyData.noDeal.push(0);
                        returnJson['Overall'][customerPOVPBCConfiguration[p].Product][customerPOVPBCConfiguration[0].data[i].Line_Item].monthlyData.delta.push(0);
                    }
                }
            }
            for (var key in returnJson) {
                if (key != 'Overall') {
                    for (let product in returnJson[key]) {
                        for (var innerKey in returnJson[key][product]) {
                            for (var m = 0; m < dates.length; m++) {
                                returnJson['Overall'][product][innerKey].monthlyData.deal[m] += returnJson[key][product][innerKey].monthlyData.deal[m];
                                returnJson['Overall'][product][innerKey].monthlyData.noDeal[m] += returnJson[key][product][innerKey].monthlyData.noDeal[m];
                                returnJson['Overall'][product][innerKey].monthlyData.delta[m] += returnJson[key][product][innerKey].monthlyData.delta[m];
                            }
                        }
                    }
                }
            }
        }
        return returnJson;

    }

}
